export default __webpack_public_path__ + "static/media/welcome-samples.d67c33a0.gif";